import { Injectable } from '@angular/core';
import { EChartOption, ECharts, EChartTitleOption } from 'echarts';
import { CommonService } from './common.service';
import * as background from '../config/backgroundColor';
import * as color from '../config/colors';
import { isNil } from 'lodash';
import { title } from 'process';

@Injectable({
  providedIn: 'root'
})
export class ChartResizeService {

  constructor(
    private commonService: CommonService
  ) { }

  style: any = this.commonService.changeFontSize();

  // 适用于直角坐标系图
  autoResizeAdapt(echartInstance: ECharts, option: any) {
    let style = this.commonService.changeFontSize();
    let xAxisResizeItem = [];
    let yAxisResizeItem = [];
    let seriesResizeItem = [];
    let titleResizeItem = {};
    // x轴
    for (let i = 0; i < option.xAxis.length; i++) {
      xAxisResizeItem.push(
        {
          axisLabel: {
            fontSize: style.fontSize - 1
          },
          nameTextStyle: {
            fontSize: style.fontSize
          }
        }
      );
    }
    for (let i = 0; i < option.yAxis.length; i++) {
      yAxisResizeItem.push(
        {
          axisLabel: {
            fontSize: style.fontSize - 1
          },
          nameTextStyle: {
            fontSize: style.fontSize
          }
        }
      );
    }
    // series系列
    for (let i = 0; i < option.series.length; i++) {
      seriesResizeItem.push(
        {
          label: {
            fontSize: style.fontSize - 1
          },
          markArea: {
            label: {
              fontSize: style.fontSize
            }
          }
        }
      );
    }

    titleResizeItem = {
      textStyle: {
        fontSize: style.fontSize
      }
    }

    let updateItems = {
      title: titleResizeItem,
      series: seriesResizeItem,
      xAxis: xAxisResizeItem,
      yAxis: yAxisResizeItem,
      legend: {
        itemWidth: style.fontSize - 2,
        itemHeight: style.fontSize - 2,
        textStyle: {
          fontSize: style.fontSize - 1
        },
        pageIconSize: style.fontSize - 1,
        pageTextStyle: {
          fontSize: style.fontSize - 1
        }
      },
      toolbox: {
        itemSize: style.toolboxSize
      },
    };
    if (echartInstance) {
      echartInstance.setOption(updateItems)
    }
  }
  // 适用于饼图
  autoPieResizeAdapt(echartInstance: ECharts, option: any) {
    let style = this.commonService.changeFontSize();
    let seriesResizeItem = [];
    // series系列
    for (let i = 0; i < option.series.length; i++) {
      seriesResizeItem.push(
        {
          label: {
            fontSize: style.fontSize - 1
          }
        }
      );
    }

    let updateItems = {
      title: {
        textStyle: {
          fontSize: style.fontSize + 2,
        }
      },
      series: seriesResizeItem,
      legend: {
        itemWidth: style.fontSize - 2,
        itemHeight: style.fontSize - 2,
        textStyle: {
          fontSize: style.fontSize - 1
        },
        pageIconSize: style.fontSize - 1,
        pageTextStyle: {
          fontSize: style.fontSize - 1
        }
      },
      toolbox: {
        itemSize: style.toolboxSize
      }
    };
    echartInstance.setOption(updateItems)
  }
  // 试用于地图
  autoMapResizeAdapt(echartInstance: ECharts, option: any) {
    let style = this.commonService.changeFontSize();
    let seriesResizeItem = [];

    let updateItems = {};
    let visualMapItem = {
      textStyle: {
        fontSize: style.fontSize - 2
      }
    };

    for (let i = 0; i < option.series.length; i++) {
      seriesResizeItem.push({
        label: {
          fontSize: style.fontSize - 2
        }
      })
    }

    if (option.visualMap.type == 'piecewise') {
      visualMapItem['itemWidth'] = style.fontSize - 6
      visualMapItem['itemHeight'] = style.fontSize
    }

    updateItems = {
      visualMap: visualMapItem,
      geo: {
        label: {
          fontSize: style.fontSize - 2
        }
      },
      series: seriesResizeItem
    }
    echartInstance.setOption(updateItems)
  }
  // 适用于仪表盘
  autoResizeAdaptGauge(echartInstance: ECharts, option: any) {
    let style = this.commonService.changeFontSize();
    let seriesResizeItem: EChartOption.SeriesGauge[] = [];

    let updateItems = {};

    for (let i = 0; i < option.series.length; i++) {
      seriesResizeItem.push({
        axisLabel: {
          fontSize: style.fontSize - 2
        },
        detail: {
          fontSize: style.fontSize + 2,
          rich: {
            a: {
              fontSize: style.fontSize,
              lineHeight: style.fontSize + 4
            },
            b: {
              fontSize: style.fontSize - 2,
              lineHeight: style.fontSize + 4
            },
            c: {
              fontSize: style.fontSize + 10
            }
          }
        },

      })
    }

    updateItems = {
      series: seriesResizeItem
    }

    echartInstance.setOption(updateItems)
  }
  // 适用于label在内部 带rich的饼图
  autoResizeAdaptPieWithRichLabel(echartInstance: ECharts, options: any) {
    let style = this.commonService.changeFontSize();
    let seriesResizeItem: EChartOption.SeriesPie[] = [];
    let title: EChartTitleOption = {};

    for (let i = 0; i < options.series.length; i++) {
      seriesResizeItem.push({

        label: {
          rich: {
            level1: {
              fontSize: style.fontSize + 16,
              lineHeight: style.fontSize + 20
            },
            level2: {
              fontSize: style.fontSize + 4,
              lineHeight: style.fontSize + 10
            },
            level3: {
              fontSize: style.fontSize,
              lineHeight: style.fontSize + 4
            },
            unit: {
              fontSize: style.fontSize - 2
            },
          }
        }
      })
    }

    title = {
      textStyle: {
        fontSize: style.fontSize + 2,
        fontWeight: 500
      }
    }

    let updateItems = {}
    updateItems = {
      title: title,
      series: seriesResizeItem
    }

    echartInstance.setOption(updateItems, false);
  }

  openSmallMode(option: any, smallMode: boolean, legendPosition: string) {
    if (smallMode) {
      switch (legendPosition) {
        case 'bottom':
          option.grid = this.style.smallInterval;
          break;
        case 'top':
          option.grid = this.style.smallTopLegendGrid;
          break;
        case 'right':
          option.grid = this.style.smallRightLegendGrid;
          break;
        case 'none':
          option.grid = this.style.smallNoLegendGrid;
          break;
        default:
          option.grid = this.style.smallInterval;
          break;
      }
    } else {
      switch (legendPosition) {
        case 'bottom':
          option.grid = this.style.interval;
          break;
        case 'top':
          option.grid = this.style.topLegendGrid;
          break;
        case 'right':
          option.grid = this.style.rightLegendGrid;
          break;
        case 'none':
          option.grid = this.style.noLegendGrid;
          break;
        default:
          option.grid = this.style.interval;
          break;
      }
    }
  }

  openPieSmallMode(option: any, smallMode: boolean, legendPosition: string) {
    if (smallMode) {
      option['series'].forEach(e => {
        e['radius'] = "80%"
      });
    }
  }

  openRosePieSmallMode(option: any, smallMode: boolean, legendPosition: string) {
    if (smallMode) {
      option['series'].forEach(e => {
        e['radius'] = ["30%", "80%"];
      });
    }
  }


  openPyramidSmallMode(option: any, smallMode: boolean) {
    if (smallMode) {
      option.grid = this.style.smallPyramidGrid;
    } else {
      option.grid = this.style.pyramidGrid;
    }
  }



  configSplitLine(show: boolean, chartOption: any, axisType: string = 'y') {
    if (axisType === 'y') {
      chartOption.yAxis.forEach(e => {
        if (isNil(e['splitLine'])) {
          e['splitLine'] = {
            show: show
          };
        } else {
          e['splitLine']['show'] = show;
        }
      });
    } else {
      chartOption.xAxis.forEach(e => {
        if (isNil(e['splitLine'])) {
          e['splitLine'] = {
            show: show
          };
        } else {
          e['splitLine']['show'] = show;
        }
      });
    }
  }
}
